import { useQuery } from "@apollo/client/react";
import type { FreeTrialFragmentFragment } from "@repo/graphql/documents/workspace/fragment.generated";
import { WorkspaceFreeTrialDocument } from "@repo/graphql/documents/workspace/query.generated";

export type FreeTrial = FreeTrialFragmentFragment;

type UseFreeTrialResult = {
  /** The running or expired free trial; null for workspaces without one. */
  trial: FreeTrial | null;
  loading: boolean;
  /** Re-reads the counters (e.g. after opening a chat). */
  refetch: () => void;
};

/** The workspace's free trial. Doesn't depend on the brand context, so it also
 *  works inside `ModalProvider` content. Refreshed on entry so the counters
 *  (work orders, chats) are current. */
export const useFreeTrial = (): UseFreeTrialResult => {
  const { data, loading, refetch } = useQuery(WorkspaceFreeTrialDocument, {
    fetchPolicy: "cache-and-network",
  });
  return {
    trial:
      data?.workspace.myWorkspace?.workspace.workspaceplan.freeTrial ?? null,
    loading: loading && !data,
    refetch: () => {
      void refetch();
    },
  };
};
